/*
 * @Description: 引导页
 * @Author: ZY
 * @Date: 2021-01-21 20:13:03
 * @LastEditors: ZY
 * @LastEditTime: 2021-01-21 21:24:27
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const MarketRouter: Array<RouteRecordRaw> = [
  {
    path: '/market',
    component: Layout,
    redirect: '/market/index',
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "guide" */ '@/views/market/Index.vue'),
        name: 'Market',
        meta: {
          title: 'market',
          icon: '#iconguide'
        }
      } 
    ]
  }
]

export default MarketRouter
